import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { MeasurementsPage } from './MeasurementsPage'
import { StepsPage } from './StepsPage'
import { WeightPage } from './WeightPage'

export const routes: RouteObject[] = [
  { path: '/health/weight', element: <WeightPage /> },
  { path: '/health/measurements', element: <MeasurementsPage /> },
  { path: '/health/steps', element: <StepsPage /> },
]

// Здесь объявлен сам раздел «Здоровье»: другие вкладки (давление, самочувствие, …) добавляют
// только свои пункты с parent: '/health'. Голый /health ведёт на первую вкладку — «Вес».
export const nav: NavItem[] = [
  { path: '/health', label: 'Здоровье', icon: 'health', mobile: 'tab', order: 40 },
  { path: '/health/weight', label: 'Вес', icon: 'health', mobile: null, order: 10, parent: '/health' },
  { path: '/health/measurements', label: 'Замеры', icon: 'target', mobile: null, order: 20, parent: '/health' },
  { path: '/health/steps', label: 'Шаги', icon: 'activity', mobile: null, order: 25, parent: '/health' },
]
